import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const conversion = ({ conversion: _conversion }: VehicleStatsByCompany): string => {
    return _conversion ? `${_conversion}%` : '--'
}

export default conversion
